import { useState, useEffect, useCallback } from "react";
import { getDashboardMetrics } from "../../api/dashboardApi";

/**
 * @param {string} [zoneName] - optional zone_name to filter metrics by.
 *   Pass undefined/omit to fetch the unfiltered ("All Zones") metrics.
 */
export default function useDashboardMetrics(zoneName) {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMetrics = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getDashboardMetrics(zoneName);
      setMetrics(data);
    } catch (err) {
      console.error("Failed to load dashboard metrics:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [zoneName]);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return { metrics, loading, error, fetchMetrics };
}